import * as variables from 'variables';

export default function enableScrollHandler() {
	if (!variables._loadingInProgress) {
		variables._didScroll = true;
	}
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/enableScrollHandler.js
 **/